(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6134],{

/***/ 82624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IndexView; }
/* harmony export */ });
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78402);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




function IndexView(props) {
  var pageKey = props.pageKey,
      _props$menu = props.menu,
      menu = _props$menu === void 0 ? [] : _props$menu,
      title = props.title,
      bgImage = props.bgImage,
      _props$bgImageMobile = props.bgImageMobile,
      bgImageMobile = _props$bgImageMobile === void 0 ? bgImage : _props$bgImageMobile,
      className = props.className;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("section", {
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().container), className),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
      className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["for-pc"]),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("header", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().header),
        style: {
          backgroundImage: "url(".concat(bgImage, ")")
        },
        children: title
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
      className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["for-mobile"]),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("header", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().header),
        style: {
          backgroundImage: "url(".concat(bgImageMobile, ")")
        },
        children: title
      })
    }), menu.length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("nav", {
      className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().nav),
      children: menu.map(function (item) {
        var key = item.key,
            text = item.text,
            _item$target = item.target,
            target = _item$target === void 0 ? '_self' : _item$target;
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
          className: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().navItem), pageKey === item.key && (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().active)),
          target: target,
          rel: "noreferrer",
          href: item.link,
          children: text
        }, key);
      })
    })]
  });
}

/***/ }),

/***/ 39609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _style_index_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29448);
/* harmony import */ var _style_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_style_index_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
// loading





var Loading = function Loading(props) {
  var _props$visible = props.visible,
      visible = _props$visible === void 0 ? true : _props$visible,
      children = props.children,
      style = props.style;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
    className: (_style_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().loading),
    style: style,
    children: visible ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        width: "32",
        height: "32",
        fill: "#44b5ff",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
          opacity: ".25",
          d: "M16 0 A16 16 0 0 0 16 32 A16 16 0 0 0 16 0 M16 4 A12 12 0 0 1 16 28 A12 12 0 0 1 16 4"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
          d: "M16 0 A16 16 0 0 1 32 16 L28 16 A12 12 0 0 0 16 4z",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("animateTransform", {
            attributeName: "transform",
            type: "rotate",
            from: "0 16 16",
            to: "360 16 16",
            dur: "0.8s",
            repeatCount: "indefinite"
          })
        })]
      })
    }) : children
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Loading);

/***/ }),

/***/ 24482:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Home; }
/* harmony export */ });
/* harmony import */ var antd_lib_list_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69870);
/* harmony import */ var antd_lib_list_style__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(antd_lib_list_style__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var antd_lib_list__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(9922);
/* harmony import */ var _workspace_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(27812);
/* harmony import */ var antd_lib_pagination_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45822);
/* harmony import */ var antd_lib_pagination_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(antd_lib_pagination_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var antd_lib_pagination__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(16661);
/* harmony import */ var _workspace_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59499);
/* harmony import */ var _workspace_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(50029);
/* harmony import */ var _workspace_repo_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87794);
/* harmony import */ var _workspace_repo_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_workspace_repo_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var components_layout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16569);
/* harmony import */ var components_button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(89231);
/* harmony import */ var styles_news_index_module_scss__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(60524);
/* harmony import */ var styles_news_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(styles_news_index_module_scss__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67294);
/* harmony import */ var components_loading__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(39609);
/* harmony import */ var action_index__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(37121);
/* harmony import */ var components_banner__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(82624);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(85893);








function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_workspace_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









//import { pageSize } from 'constants/index';






var pcBanner = 'https://devcdn.xylink.com/xylink_website_doc/images/replace/news/pc/pc-company-dynamic-title.jpg';
var mobileBanner = 'https://devcdn.xylink.com/xylink_website_doc/images/replace/news/mobile/m-company-dynamic-title.jpg';
var pageSize = 20;
var __N_SSG = true;
function Home(props) {
  var list = props.list,
      current = props.current,
      total = props.total;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();

  if (router.isFallback) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(components_loading__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {});
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)(components_layout__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_4___default()), {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("title", {
        children: "\u65B0\u95FB\u4E2D\u5FC3 - \u5C0F\u9C7C\u6613\u8FDE-\u5B98\u7F51-\u8BA9\u4E16\u754C\u96F6\u8DDD\u79BB"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("section", {
      className: (styles_news_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().container),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(components_banner__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
        bgImage: pcBanner,
        bgImageMobile: mobileBanner,
        title: "\u516C\u53F8\u65B0\u95FB"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("div", {
        className: (styles_news_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().body),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(MobileList, {
          list: list,
          total: total,
          current: current
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(PcList, {
          list: list,
          total: total,
          current: current
        })]
      })]
    })]
  });
}

var Item = function Item(item) {
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();

  var onViewInfo = function onViewInfo() {
    router.push("/news/".concat(item.id));
  };

  var newsAuthor = item.newsAuthor && item.newsAuthor.length > 10 ? "".concat(item.newsAuthor.substring(0, 10), "...") : item.newsAuthor;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("div", {
    className: (styles_news_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().newsItem),
    onClick: onViewInfo,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("div", {
      className: (styles_news_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().logo),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("img", {
        src: item.newsCover,
        alt: item.newsTitle
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("div", {
      className: (styles_news_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().content),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("div", {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("div", {
          className: (styles_news_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().title),
          children: item.newsTitle
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("div", {
          className: classnames__WEBPACK_IMPORTED_MODULE_12___default()((styles_news_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().desc), 'for-pc'),
          children: item.newsSummary
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("div", {
        className: (styles_news_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().date),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("span", {
          children: item.releaseTime
        }), newsAuthor && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("span", {
          className: classnames__WEBPACK_IMPORTED_MODULE_12___default()((styles_news_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().author), 'for-pc'),
          children: ["\u53D1\u5E03\u8005\uFF1A", newsAuthor]
        })]
      })]
    })]
  }, item.id);
};

var PcList = function PcList(props) {
  var list = props.list,
      current = props.current,
      newsTotal = props.total;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(list),
      newsList = _useState[0],
      setNewsList = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(newsTotal),
      total = _useState2[0],
      setTotal = _useState2[1];

  var onChangePage = /*#__PURE__*/function () {
    var _ref = (0,_workspace_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)( /*#__PURE__*/_workspace_repo_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default().mark(function _callee(page) {
      var res, _total, records;

      return _workspace_repo_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return action_index__WEBPACK_IMPORTED_MODULE_10__/* .action.getNewsList */ .a.getNewsList(page, pageSize);

            case 2:
              res = _context.sent;

              if (res) {
                _total = res.total, records = res.records;
                setNewsList(records);
                setTotal(_total);
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onChangePage(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_12___default()((styles_news_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().pcWrapper), (styles_news_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["for-pc"])),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("div", {
      className: (styles_news_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().newsList),
      children: newsList.map(function (item) {
        return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_8__.createElement)(Item, _objectSpread(_objectSpread({}, item), {}, {
          key: item.id
        }));
      })
    }), total > pageSize && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(antd_lib_pagination__WEBPACK_IMPORTED_MODULE_16__["default"], {
      showLessItems: true,
      className: (styles_news_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().pagination),
      total: total,
      defaultCurrent: current,
      showSizeChanger: false,
      pageSize: pageSize,
      onChange: onChangePage
    })]
  });
};

var MobileList = function MobileList(props) {
  var list = props.list,
      current = props.current,
      newsTotal = props.total;

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(list),
      newsList = _useState3[0],
      setNewsList = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(newsTotal),
      total = _useState4[0],
      setTotal = _useState4[1]; // 移动端


  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(false),
      loading = _useState5[0],
      setLoading = _useState5[1];

  var page = (0,react__WEBPACK_IMPORTED_MODULE_8__.useRef)(current);

  var onLoadMore = /*#__PURE__*/function () {
    var _ref2 = (0,_workspace_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)( /*#__PURE__*/_workspace_repo_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default().mark(function _callee2() {
      var res, _total2, records;

      return _workspace_repo_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setLoading(true);
              page.current += 1;
              _context2.next = 4;
              return action_index__WEBPACK_IMPORTED_MODULE_10__/* .action.getNewsList */ .a.getNewsList(page.current, pageSize);

            case 4:
              res = _context2.sent;

              if (res) {
                _total2 = res.total, records = res.records;
                setTotal(_total2);
                setNewsList(function (list) {
                  return [].concat((0,_workspace_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(list), (0,_workspace_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(records));
                });
              }

              setLoading(false);

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function onLoadMore() {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(antd_lib_list__WEBPACK_IMPORTED_MODULE_18__["default"], {
    className: classnames__WEBPACK_IMPORTED_MODULE_12___default()((styles_news_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().newsList), (styles_news_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["for-mobile"])) // loading={initLoading}
    ,
    itemLayout: "horizontal",
    loadMore: total > newsList.length && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(components_button__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
      category: "viewMore",
      className: (styles_news_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().loadMore),
      onClick: onLoadMore,
      loading: loading,
      children: "\u67E5\u770B\u66F4\u591A..."
    }),
    dataSource: newsList,
    renderItem: function renderItem(item) {
      return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_8__.createElement)(Item, _objectSpread(_objectSpread({}, item), {}, {
        key: item.id
      }));
    }
  });
};

/***/ }),

/***/ 88097:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news",
      function () {
        return __webpack_require__(24482);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 78402:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"banner_container__oBe7a","nav":"banner_nav__R4D9K","navItem":"banner_navItem__z8je4","header":"banner_header__8mEeU","border__px":"banner_border__px__Rkq8K","border__px-before":"banner_border__px-before__jqV1R","border__px-before1":"banner_border__px-before1__rZGud","border-children1":"banner_border-children1__cwgjz","border-children2":"banner_border-children2__7N7DQ","for-mobile":"banner_for-mobile__9iMXJ","for-pc":"banner_for-pc__zlWnK","active":"banner_active___c3ly"};

/***/ }),

/***/ 29448:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loading":"style_loading__4oDXS","loading-content":"style_loading-content__VXWzP"};

/***/ }),

/***/ 60524:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"body":"news_body__FGJRy","border__px":"news_border__px__anskU","border__px-before":"news_border__px-before__1QnFE","border__px-before1":"news_border__px-before1__gBG9q","border-children1":"news_border-children1__qJWmp","border-children2":"news_border-children2__NSdFe","for-mobile":"news_for-mobile__LlMj_","for-pc":"news_for-pc__0zc3y","pcWrapper":"news_pcWrapper__GfUD1","newsList":"news_newsList__fbrxD","newsItem":"news_newsItem__aH7_h","icon":"news_icon__Y5ut9","logo":"news_logo__RN8JS","content":"news_content__KJqk2","title":"news_title__pOdjQ","desc":"news_desc__dC8Sj","date":"news_date__m_lSR","author":"news_author__3c4ot","pagination":"news_pagination__5XOOv","loadMore":"news_loadMore__IRXcH"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1747,4662,7115,8512,9774,2888,179], function() { return __webpack_exec__(88097); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);